import React from "react";
import { Link } from "react-router-dom";
import { AiOutlineRollback } from "react-icons/ai";
import "../../pages/view.css";

const ViewPromotionalDiscount = () => {
  return (
    <div class="container">
      <div className="m-3 md:m-10 mt-24 p-0 md:p-6 bg-white rounded-3xl">
        <div class="flex justify-end active">
          <div class="backIcon">
            <Link to="/promotionaldiscount">
              <AiOutlineRollback />
            </Link>
          </div>
        </div>
        <div class="flex justify-center text-left">
          <ul class="bg-white rounded-lg w-96 text-gray-900">
            <div class="data">
              <li class="px-6 py-2 border-b border-gray-200 w-full rounded-t-lg">
                Merchant : Shree
              </li>
              <li class="px-6 py-2 border-b border-gray-200 w-full">
                Percentage Discount : 10%
              </li>
              <li class="px-6 py-2 border-b border-gray-200 w-full">
              Validity From : 2022-05-05 18:20:00
              </li>
              <li class="px-6 py-2 w-full rounded-b-lg">
              Validity To : 2022-05-05 18:20:00
              </li>
            </div>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ViewPromotionalDiscount;
